import { AST } from '@handlebars/parser';
import { NodeType } from '../../../node/types';

export const isUndefinedLiteral = (expression: AST.Node): expression is AST.UndefinedLiteral =>
  expression.type === NodeType.UndefinedLiteral;
